module.exports = __webpack_public_path__ + "img/slides-image@3x.0469b049.png";